<div id="header-search" class="header-search">
  <button type="button" class="close">×</button>
  <form class="header-search-form">
      <input type="search" value="" placeholder="Type here........" />
      <button type="submit" class="btn btn-primary">Search</button>
  </form>
</div>
